import { createElement, Children, PureComponent } from 'react';

var key = (function () {
  return Math.random().toString(36).substring(2);
});

var removeKeys = (function (blackList) {
  return function (obj) {
    var cleanObj = obj;

    blackList.forEach(function (item) {
      return Object.prototype.hasOwnProperty.call(cleanObj, item) && delete cleanObj[item];
    });

    return cleanObj;
  };
});

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var blackListProps = ["rowGap", "columnWidth"];
var removeBlackListed = removeKeys(blackListProps);

var Snuggle = function (_React$PureComponent) {
  inherits(Snuggle, _React$PureComponent);

  function Snuggle() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Snuggle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Snuggle.__proto__ || Object.getPrototypeOf(Snuggle)).call.apply(_ref, [this].concat(args))), _this), _this.reposition = false, _this.elements = [], _this.grid = null, _this.getRef = function (ref) {
      if (ref && ref.firstElementChild) {
        _this.elements.push(ref);
      }
    }, _this.setValues = function () {
      var _this$props$rowGap = _this.props.rowGap,
          rowGap = _this$props$rowGap === undefined ? 0 : _this$props$rowGap;


      if (_this.elements.length === 0) return;

      _this.elements.forEach(function (item) {
        var itemRef = item;

        if (itemRef && itemRef.firstElementChild) {
          var firstElement = itemRef.firstElementChild;
          var itemHeight = firstElement.getBoundingClientRect().height;
          var rowSpan = Math.ceil((itemHeight + rowGap) / rowGap);

          itemRef.style.gridRowEnd = "span " + rowSpan;
        }

        return null;
      });

      if (!_this.reposition) {
        window.requestAnimationFrame(_this.setValues);
        _this.reposition = true;
      }
    }, _this.onLoadImages = function () {
      if (_this.grid) {
        var images = _this.grid.getElementsByTagName("img");

        Array.from(images).forEach(function (img) {
          var imageRef = img;

          imageRef.onload = function () {
            _this.setValues();
          };
        });
      }
    }, _this.createGridStyle = function () {
      var _this$props = _this.props,
          _this$props$rowGap2 = _this$props.rowGap,
          rowGap = _this$props$rowGap2 === undefined ? 0 : _this$props$rowGap2,
          _this$props$columnWid = _this$props.columnWidth,
          columnWidth = _this$props$columnWid === undefined ? 0 : _this$props$columnWid;


      return {
        display: "grid",
        gridGap: rowGap + "px",
        gridTemplateColumns: "repeat(auto-fill, minmax(" + columnWidth + "px, 1fr))"
      };
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Snuggle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setValues();
      this.onLoadImages();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setValues();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          _props$item = _props.item,
          item = _props$item === undefined ? createElement("div") : _props$item,
          _props$container = _props.container,
          container = _props$container === undefined ? createElement("div") : _props$container,
          compProps = objectWithoutProperties(_props, ["children", "item", "container"]);


      var hasChildren = Children.count(children) > 0;

      if (!hasChildren) return null;

      var refItem = function refItem(n) {
        _this2.getRef(n);
      };
      var refGrid = function refGrid(n) {
        _this2.grid = n;
      };

      var renderChildren = Children.map(children, function (child) {
        var itemProps = removeBlackListed(_extends({}, item.props, {
          ref: refItem,
          innerRef: refItem,
          key: key()
        }));

        if (item) {
          return createElement(item.type, itemProps, child);
        }

        return null;
      });

      var containerProps = removeBlackListed(_extends({}, container.props, compProps, {
        style: _extends({}, container.props.style, this.createGridStyle()),
        ref: refGrid
      }));

      return createElement(container.type, containerProps, renderChildren);
    }
  }]);
  return Snuggle;
}(PureComponent);

Snuggle.defaultProps = {
  rowGap: 20,
  columnWidth: 250,
  container: createElement("div"),
  item: createElement("div")
};

export default Snuggle;



//////////////////
// WEBPACK FOOTER
// ./~/react-snuggle/dist/react-snuggle.es.js
// module id = 475
// module chunks = 0